
<div class="row">
    <div class="col-12">
  
        <div class="card">
            <div class="card-header">
                <div class="title"> История выгрузок товаров по спецификации</div>
                <div class="tools">
                </div>
            </div>
            <div class="card-body table-block">

                <table class="table">
                    <thead>
                        <tr>
                            <th scope="col" class="name">{{ 'NAME' | translate }}</th>
                            <th scope="col" class="date"> Дата выгрузки</th>
                            <th scope="col" class="user"> Пользователь</th>
                            <th scope="col" class="action"></th>
                        </tr>
                    </thead>

                    <tbody *ngIf="specificationsHistory.length > 0">

                        <tr *ngFor="let item of specificationsHistory">
                            
                            <td class="products">{{ item.name }}</td>
                            <td class="products">{{ item.date | date: 'dd.MM.yyyy HH:mm' }}</td>
                            <td class="products">{{ item.user }}</td>
                            
                            <td class="action">
                                <div class="action-btn">
                                    <button type="button" class="btn btn-none btn-download"  placement="top" ngbTooltip="{{ 'PRODUCT.REPEAT_UPLOAD' | translate }}" tooltipClass="clue-name" [closeDelay]="300" (click)="onDownload(item)">
                                        <svg-icon class="" src="/assets/images/icons/download.svg" [stretch]="true"
                                        [svgStyle]="{'width.px':18, 'height.px':18}"></svg-icon>
                                    </button>
                                    <button type="button" class="btn btn-none btn-download" placement="top" ngbTooltip="{{ 'PRODUCT.APPLY_SETTING_FROM_UPLOAD_TO_SELECTED_PRODUCTS' | translate }}" tooltipClass="clue-name" [closeDelay]="300" (click)="onEditDownload(item)">
                                        <svg-icon class="" src="/assets/images/icons/loop.svg" [stretch]="true"
                                        [svgStyle]="{'width.px':18, 'height.px':18}"></svg-icon>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>

                    <tbody *ngIf="specificationsHistory.length == 0">
                        <tr>
                            <td *ngIf="loading" class="data-loading" colspan="4">
                                <div>{{ 'LOADING' | translate }}</div>
                            </td>
                            <td *ngIf="!loading" class="data-not-found" colspan="4">
                                <div>{{ 'DATA_NOT_FOUND' | translate }}</div>
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>
        </div>

    </div>
</div>